import styled from 'styled-components';
import { variables } from '@splunk/themes';
import { Modal } from '../Modal';

export const StyledModal = styled(Modal)`
    width: 550px;

    // This is a workaround because jest won't compile code properly
    // Modal.test mocks Modal so styled(Modal.Body) doesn't work in other files (it works in reality, just not in jest)
    & > [data-test='body'] {
        padding: ${variables.spacingXLarge};
        padding-top: ${variables.spacingMedium};
    }
`;
